import React, { Component } from "react";
import axios from "axios";

class AboutUs extends Component {
  constructor() {
    super();
    this.state = {
      amount: 0, // Default amount
      id: 0, // Default id
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    // Extract "amount" and "id" from URL query parameters
    const queryParams = new URLSearchParams(window.location.search);
    const amountFromUrl = queryParams.get("amount");
    const idFromUrl = queryParams.get("id");

    const parsedAmount = amountFromUrl ? parseFloat(amountFromUrl) : 0;
    const parsedId = idFromUrl ? parseFloat(idFromUrl) : 0;

    if (!isNaN(parsedAmount) && !isNaN(parsedId) && parsedAmount > 0 && parsedId > 0) {
      this.setState({ amount: parsedAmount, id: parsedId }, () => {
        this.selectPlan(); // Auto-trigger payment after state update
      });
    }
  }

  async selectPlan() {
    const { amount, id } = this.state;

    if (!amount || isNaN(amount) || !id || isNaN(id)) {
      alert("Invalid payment details. Please try again.");
      return;
    }

    let formData = new FormData();
    formData.append("amount", amount);
    formData.append("id", id);

    try {
      let response = await axios.post("https://api.shopperr.in/pg/pay", formData);

      if (response.data && response.data.redirectUrl) {
        window.open(response.data.redirectUrl, "_blank");
      } else {
        alert("Payment initiation failed. Please try again.");
      }
    } catch (error) {
      console.error("Payment failed:", error);
      alert("Payment failed. Please try again.");
    }
  }

  render() {
    return (
      <div className="wrapper">
        <p>Processing payment for: ₹{this.state.amount}</p>
      </div>
    );
  }
}

export default AboutUs;
